import { createGlobalStyle } from 'styled-components';

// WOFF Type
import IRANYekanWoffBold from '../assets/fonts/IRANYekan/woff/iranyekanwebbold.woff';
import IRANYekanWoffThin from '../assets/fonts/IRANYekan/woff/iranyekanwebthin.woff';
import IRANYekanWoffLight from '../assets/fonts/IRANYekan/woff/iranyekanweblight.woff';
import IRANYekanWoffRegular from '../assets/fonts/IRANYekan/woff/iranyekanwebregular.woff';
import IRANYekanWoffMedium from '../assets/fonts/IRANYekan/woff/iranyekanwebmedium.woff';
import IRANYekanWoffExtraBold from '../assets/fonts/IRANYekan/woff/iranyekanwebextrabold.woff';
import IRANYekanWoffBlack from '../assets/fonts/IRANYekan/woff/iranyekanwebblack.woff';
import IRANYekanWoffExtraBlack from '../assets/fonts/IRANYekan/woff/iranyekanwebextrablack.woff';

// EOT Type
import IRANYekanEotBold from '../assets/fonts/IRANYekan/eot/iranyekanwebbold.eot';
import IRANYekanEotThin from '../assets/fonts/IRANYekan/eot/iranyekanwebthin.eot';
import IRANYekanEotLight from '../assets/fonts/IRANYekan/eot/iranyekanweblight.eot';
import IRANYekanEotRegular from '../assets/fonts/IRANYekan/eot/iranyekanwebregular.eot';
import IRANYekanEotMedium from '../assets/fonts/IRANYekan/eot/iranyekanwebmedium.eot';
import IRANYekanEotExtraBold from '../assets/fonts/IRANYekan/eot/iranyekanwebextrabold.eot';
import IRANYekanEotBlack from '../assets/fonts/IRANYekan/eot/iranyekanwebblack.eot';
import IRANYekanEotExtraBlack from '../assets/fonts/IRANYekan/eot/iranyekanwebextrablack.eot';

// TTF Type
import IRANYekanTtfBold from '../assets/fonts/IRANYekan/ttf/iranyekanwebbold.ttf';
import IRANYekanTtfThin from '../assets/fonts/IRANYekan/ttf/iranyekanwebthin.ttf';
import IRANYekanTtfLight from '../assets/fonts/IRANYekan/ttf/iranyekanweblight.ttf';
import IRANYekanTtfRegular from '../assets/fonts/IRANYekan/ttf/iranyekanwebregular.ttf';
import IRANYekanTtfMedium from '../assets/fonts/IRANYekan/ttf/iranyekanwebmedium.ttf';
import IRANYekanTtfExtraBold from '../assets/fonts/IRANYekan/ttf/iranyekanwebextrabold.ttf';
import IRANYekanTtfBlack from '../assets/fonts/IRANYekan/ttf/iranyekanwebblack.ttf';
import IRANYekanTtfExtraBlack from '../assets/fonts/IRANYekan/ttf/iranyekanwebextrablack.ttf';

export default createGlobalStyle`
    @font-face {
        font-family: 'IRAN Yekan';
        font-weight: 300;
        font-style: normal;
        src: url(${IRANYekanEotBold});
        src: url(${IRANYekanEotBold}?#iefix) format('embedded-opentype'),  /* IE6-8 */
            url(${IRANYekanWoffBold}) format('woff'),  /* FF3.6+, IE9, Chrome6+, Saf5.1+*/
            url(${IRANYekanTtfBold}) format('truetype');
    }

    @font-face {
        font-family: 'IRAN Yekan';
        font-weight: 100;
        font-style: normal;
        src: url(${IRANYekanEotThin});
        src: url(${IRANYekanEotThin}?#iefix) format('embedded-opentype'),  /* IE6-8 */
            url(${IRANYekanWoffThin}) format('woff'),  /* FF3.6+, IE9, Chrome6+, Saf5.1+*/
            url(${IRANYekanTtfThin}) format('truetype');
    }

    @font-face {
        font-family: 'IRAN Yekan';
        font-weight: 300;
        font-style: normal;
        src: url(${IRANYekanEotLight});
        src: url(${IRANYekanEotLight}?#iefix) format('embedded-opentype'),  /* IE6-8 */
            url(${IRANYekanWoffLight}) format('woff'),  /* FF3.6+, IE9, Chrome6+, Saf5.1+*/
            url(${IRANYekanTtfLight}) format('truetype');
    }
    
    @font-face {
        font-family: 'IRAN Yekan';
        font-weight: normal;
        font-style: normal;
        src: url(${IRANYekanEotRegular});
        src: url(${IRANYekanEotRegular}?#iefix) format('embedded-opentype'),  /* IE6-8 */
            url(${IRANYekanWoffRegular}) format('woff'),  /* FF3.6+, IE9, Chrome6+, Saf5.1+*/
            url(${IRANYekanTtfRegular}) format('truetype');
    }

    @font-face {
        font-family: 'IRAN Yekan';
        font-weight: 500;
        font-style: normal;
        src: url(${IRANYekanEotMedium});
        src: url(${IRANYekanEotMedium}?#iefix) format('embedded-opentype'),  /* IE6-8 */
            url(${IRANYekanWoffMedium}) format('woff'),  /* FF3.6+, IE9, Chrome6+, Saf5.1+*/
            url(${IRANYekanTtfMedium}) format('truetype');
    }

    @font-face {
        font-family: 'IRAN Yekan';
        font-weight: 800;
        font-style: normal;
        src: url(${IRANYekanEotExtraBold});
        src: url(${IRANYekanEotExtraBold}?#iefix) format('embedded-opentype'),  /* IE6-8 */
            url(${IRANYekanWoffExtraBold}) format('woff'),  /* FF3.6+, IE9, Chrome6+, Saf5.1+*/
            url(${IRANYekanTtfExtraBold}) format('truetype');
    }

    @font-face {
        font-family: 'IRAN Yekan';
        font-weight: 900;
        font-style: normal;
        src: url(${IRANYekanEotBlack});
        src: url(${IRANYekanEotBlack}?#iefix) format('embedded-opentype'),  /* IE6-8 */
            url(${IRANYekanWoffBlack}) format('woff'),  /* FF3.6+, IE9, Chrome6+, Saf5.1+*/
            url(${IRANYekanTtfBlack}) format('truetype');
    }

    @font-face {
        font-family: 'IRAN Yekan';
        font-weight: 950;
        font-style: normal;
        src: url(${IRANYekanEotExtraBlack});
        src: url(${IRANYekanEotExtraBlack}?#iefix) format('embedded-opentype'),  /* IE6-8 */
            url(${IRANYekanWoffExtraBlack}) format('woff'),  /* FF3.6+, IE9, Chrome6+, Saf5.1+*/
            url(${IRANYekanTtfExtraBlack}) format('truetype');
    }

    body {
        font-family: 'IRAN Yekan'  !important;
        direction: rtl;
    }
        h1, h2, h3, h4, h5, h6,input, textarea {
            font-family: 'IRAN Yekan' !important;
        }
    h1 {
        font-weight: bold;
    }
`;
